module.exports = __webpack_public_path__ + "img/logo-圆.6293a6e0.png";